import { Suspense } from 'react';
import { NotificationContainer } from 'react-notifications';
import { QueryClientProvider } from 'react-query';
import Loading from 'shared/layout/Loading';
import MainWrapper from 'shared/layout/MainWrapper';
import { useTheme } from 'shared/theme/useTheme';
import { queryClient } from 'shared/utils/queryClient';
import { ThemeProvider } from 'styled-components';

export default function AppShell({ children }) {
  const { theme } = useTheme();
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <NotificationContainer />
        <Suspense fallback={<Loading />}>
          <MainWrapper>{children}</MainWrapper>
        </Suspense>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
